module.exports = __webpack_public_path__ + "img/20.bd10a16a.png";